<template>
  <card>
    <div class="row">
      <div class="col-12">
        <p>Welcome to the Sensoreal Admin Dashboard.</p>
      </div>
    </div>   
  </card>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import { FETCH_PAGE, FETCH_PAGES } from '@/store/actions.type'

export default {

  computed: {
    ...mapGetters([
      "pages"
    ]),
  },

  methods: {
    dataFormat: function(a, b) {
      if (b) return b + "%";
      return a;
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_PAGES);
  },
};
</script>
<style>
</style>
